<script lang="ts">
    import { _ } from "svelte-i18n"
    import { onMount } from "svelte"
    import PurchaseFeedback from "./PurchaseFeedback.svelte"
    import { drainPurchaseQueue } from "../../../lib/ga"

    onMount(() => {
        // GA4 purchase aus der Reload-sicheren Queue feuern (nur mit Consent,
        // genau einmal pro Bestellnummer — sent-Flag überlebt Reloads).
        drainPurchaseQueue()
    })
</script>

<div class="subline">{$_("checkout.order")}</div>
<h2 class="h2_nooffset">{$_("checkout.thank-you-for-order")}</h2>

<section>
    <p>
        {@html $_("checkout.order-comfirmation-html")}
    </p>
</section>

<PurchaseFeedback />
